import { createRouter, createWebHistory } from 'vue-router'

import AboutView from '@/views/About/AboutView.vue'

const routes = [
  {
    path:'/areas',
    children: [
      {
        path:'/calibracoes',
        name:'areas.calibracoes',
        component: () => import(/* webpackChunkName: "about" */ '@/views/areas/CalibracoesEnsaiosView.vue')
      },
      {
        path:'/projetos',
        name:'areas.projetos',
        component: () => import(/* webpackChunkName: "about" */ '@/views/areas/ProjetosView.vue')
      },
      {
        path:'/engenharia-ambiental',
        name:'engenharia.ambiental',
        component: () => import(/* webpackChunkName: "about" */ '@/views/areas/EngenhariaAmbientalView.vue')
      },
      {
        path:'/engenharia-clinica',
        name:'engenharia.clinica',
        component: () => import(/* webpackChunkName: "about" */ '@/views/areas/EngenhariaClinicaView.vue')
      },
      {
        path:'/engenharia-eletrica',
        name:'engenharia.eletrica',
        component: () => import(/* webpackChunkName: "about" */ '@/views/areas/EngenhariaEletricaView.vue')
      },
      {
        path:'/inspecao-ultrassonica',
        name:'inspecao.ultrassonica',
        component: () => import(/* webpackChunkName: "about" */ '@/views/areas/InspecaoUltrassonicaView.vue')
      },
      {
        path:'/treinamento-operacional',
        name:'treinamento.operacional',
        component: () => import(/* webpackChunkName: "about" */ '@/views/areas/TreinamentoView.vue')
      },
    ]
    },
  {
    path: '/',
    name: 'home',
    component: () => import(/* webpackChunkName: "about" */ '@/views/HomeView.vue')
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import(/* webpackChunkName: "about" */ '@/views/contact/ContactView.vue')
  },
  {
    path: '/certificados',
    name: 'certificados',
    component: () => import(/* webpackChunkName: "about" */ '@/views/certificados/CertificadosView.vue')
  },
  {
    path: '/about',
    name: 'about',
    component: AboutView
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
